import type { SystemStyleObject } from '@chakra-ui/react';

export const resetPasswordCss: SystemStyleObject = {
  '&': {
    width: 'full',
    gap: 6,
  },

  '& .back-link': {
    fontSize: 'sm',
    alignSelf: 'center',
  },
};
